import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "position-relative"
}
const _hoisted_2 = { class: "candidate-list p-2 d-flex text-nowrap w-100 justify-content-center z-3" }

import { SELECTABLE_ITEMS } from '@/services/consts/daily_report';
import { ref, Ref, computed, onMounted, onUnmounted } from 'vue';
import DeliveryPlanType from '@/types/DeliveryPlan';

interface EditableAction {
  available: boolean;
  processing?: boolean;
}

interface EditableActions {
  alterLeaving?: EditableAction;
  alterReturning?: EditableAction;
  divide?: EditableAction;
  merge?: EditableAction;
  [key: string]: EditableAction | undefined;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EditIcon',
  props: {
    deliveryPlan: {},
    isOperationOffice: { type: Boolean },
    isDepartment: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const BUTTON_ID = `button-${props.deliveryPlan.delivery_plan_id}`;
const PULL_DOWN_ID = `drop-down-${props.deliveryPlan.delivery_plan_id}`;
const isOpenPullDown: Ref<boolean> = ref(false);

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

const displayPullDownItems = computed<{[key: string]: string}[]>(() => {
  const items: {[key: string]: string}[] = [];
  const editableActions: EditableActions = props.deliveryPlan?.editable_actions || {};
  Object.entries(editableActions).forEach(([key, action]) => {
    if (action && action.available) {
      switch (key) {
        case 'alter_leaving':
          if (!props.isOperationOffice && !props.isDepartment) {
            items.push(SELECTABLE_ITEMS['alterLeaving']);
          }
          break;
        case 'alter_returning':
          if (!props.isOperationOffice && !props.isDepartment) {
            items.push(SELECTABLE_ITEMS['alterReturning']);
          }
          break;
        case 'divide':
          items.push(SELECTABLE_ITEMS['divide']);
          break;
        case 'merge':
          items.push(SELECTABLE_ITEMS['merge']);
          break;
        case 'recreate':
          if (!props.isOperationOffice && !props.isDepartment) {
            items.push(SELECTABLE_ITEMS['recreate']);
          }
          break;
        case 'combine':
          if (!props.isOperationOffice && !props.isDepartment && props.deliveryPlan.driver) {
            items.push(SELECTABLE_ITEMS['combine']);
          }
          break;
        case 'combine_rollback':
          if (!props.isOperationOffice && !props.isDepartment) {
            items.push(SELECTABLE_ITEMS['combine_rollback']);
          }
          break;
      }
    }
  });

  return items;
});

function handleClickOutside(event: MouseEvent) {
  const target = event.target as Node;
  const targetId = (target as HTMLElement).id;
  if (targetId == BUTTON_ID) {
    return isOpenPullDown.value = true;
  }
  if (targetId != PULL_DOWN_ID) {
    return isOpenPullDown.value = false;
  }
}

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (displayPullDownItems.value.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          id: BUTTON_ID,
          class: "d-flex material-symbols-outlined text-black text-decoration-none",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleClickOutside($event)))
        }, " more_vert "),
        (isOpenPullDown.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref: "pullDownRef",
              id: PULL_DOWN_ID,
              class: "pull-down position-absolute top-0 h-100 z-3",
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayPullDownItems.value, (item) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: Object.keys(item)[0],
                  to: { name: Object.keys(item)[0], params: { id: props.deliveryPlan.delivery_plan_id }},
                  class: "d-flex text-black text-decoration-none"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(Object.values(item)[0]), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128))
            ], 512))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})